import type { ISaveSearchEvent, ISaveSearchInput } from '../types/clickEvents';

const saveSearch = (
  input: ISaveSearchInput,
): Omit<ISaveSearchEvent, 'event'> => ({
  linkDetails: input.linkDetails,
});

export default saveSearch;
